import React from 'react';
import { flashMessage as __flashMessage } from '~/app/actions';
import { useDispatch } from 'react-redux';
import useSchedule from './useSchedule';
import useCancelPendingDeployment from './useCancelPendingDeployment';
import useDeploy from './useDeploy';
import PendingDeployment from './PendingDeployment';

const PendingDeploymentContainer = (props) => {
  const dispatch = useDispatch();
  const flashMessage = (message, type) => dispatch(__flashMessage(message, type));

  const { schedule } = useSchedule();
  const { cancelPendingDeployment } = useCancelPendingDeployment();
  const { deploy } = useDeploy();

  return <PendingDeployment
    {...props}
    {...{
      flashMessage,
      schedule,
      cancelPendingDeployment,
      deploy
    }}
  />
};

export default PendingDeploymentContainer;
